"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.snackbarTransitionDuration = exports.snackbarRestDuration = exports.Snackbar = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../Text/index.js");
var _Container = require("./Container.js");
var _excluded = ["onExited", "colorSet", "showSnackbar", "className", "children"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var snackbarTransitionDuration = exports.snackbarTransitionDuration = 300;
var snackbarRestDuration = exports.snackbarRestDuration = 5000;
/**
 * Snackbars are brief, temporary messages that provide feedback about an action the user just took.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-snackbar--docs) |
 * [Encore site](https://encore.spotify.net/web/components/snackbars) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/Snackbar) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-10377&t=608qKxXhWG8gyhvB-1)
 */
var Snackbar = exports.Snackbar = /*#__PURE__*/_react["default"].forwardRef(function Snackbar(_ref, ref) {
  var onExited = _ref.onExited,
    _ref$colorSet = _ref.colorSet,
    colorSet = _ref$colorSet === void 0 ? 'base' : _ref$colorSet,
    showSnackbar = _ref.showSnackbar,
    className = _ref.className,
    children = _ref.children,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isVisible = _useState2[0],
    setIsVisible = _useState2[1];
  if (showSnackbar === undefined) {
    /* eslint-disable-next-line no-console */
    console.warn('Warning: If you are not conditionally rendering Snackbar within an aria-live region (wrapping element with role="status") the component will be inaccessible on Windows operating systems. Please use the showSnackbar prop to conditionally render Snackbar. For guidance on how to implement this, refer to our Snackbar Accessibility documentation: https://encore-web.spotify.net/?path=/docs/components-snackbar--accessibility');
  }
  (0, _react.useEffect)(function () {
    /* keep built in timer for when showSnackbar isn't passed */
    if (showSnackbar === undefined) {
      setIsVisible(true);
      var timer = setTimeout(function () {
        setIsVisible(false);
        if (onExited) {
          onExited();
        }
      }, snackbarRestDuration);
      return function () {
        return clearTimeout(timer);
      };
    }
    /* Control visibility via prop */
    if (showSnackbar) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
      if (onExited) {
        onExited();
      }
    }
    return undefined;
  }, [showSnackbar, onExited]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    role: "status"
  }, /*#__PURE__*/_react["default"].createElement(_Container.Container, Object.assign({
    ref: ref,
    className: (0, _index.addColorSet)(colorSet, className),
    $colorSet: colorSet,
    $isVisible: isVisible,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.Snackbar
  }, props), /*#__PURE__*/_react["default"].createElement(_index2.Text, {
    variant: "bodySmall",
    semanticColor: "textBase"
  }, children)));
});